import styled from "styled-components";
import { color } from "../../../styles";
import { ColumnDiv, RowDiv } from "../../../styled/commonStyles";
import { Button } from "@mui/material";

export const SearchFilterBarWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const FilterSortWrapper = styled.div`
    display: flex;
    gap: 26px;
    font-size: 16px;
    line-height: 22px;
    align-items: center;
`;

interface BoxWrapperProps {
    isClicked?: boolean;
}

export const BoxWrapper = styled.div<BoxWrapperProps>`
    display: flex;
    gap: 12px;
    padding-left: 12px;
    padding-right: 10px;
    border: 1px solid ${color.secondary.GREY_4};
    background-color: ${color.emphasis.NEUTRAL_N5};
    height: 100%;
    align-items: center;
    border-radius: 5px;

    background-color: ${(props: BoxWrapperProps) =>
        props.isClicked ? color.primary.BLUE_B100 : color.emphasis.NEUTRAL_N5};

    color: ${(props: BoxWrapperProps) => (props.isClicked ? "white" : "inherit")};

    &:hover {
        cursor: pointer;
        border-color: ${color.secondary.GREY_4};
    }
`;

export const FilterOptionsWrapper = styled.div`
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
    border: 1px solid ${color.secondary.GREY_4};
    border-radius: 5px;
    max-width: 100%;
    overflow-x: hidden;
    box-sizing: border-box;

    transition:
        opacity 0.3s ease,
        transform 0.3s ease; /* Transition for opacity and position */
    transform: translateY(-5px); /* Start slightly above */

    &.filter-options-enter {
        opacity: 0;
        transform: translateY(-10px); /* Start position */
    }

    &.filter-options-enter-active {
        opacity: 1;
        transform: translateY(0); /* Final position */
    }

    &.filter-options-exit {
        opacity: 1;
        transform: translateY(0); /* Start at final position */
    }

    &.filter-options-exit-active {
        opacity: 0;
        transform: translateY(-10px); /* Move up while closing */
    }
`;

export const FilterTitle = styled.div`
    font-size: 15px;
    line-height: 22px;
    font-weight: 600;
`;

export const FilterOptionsRow = styled(RowDiv)`
    gap: 8px;
    flex-wrap: wrap;
    align-items: flex-start;
    overflow-x: hidden;
    max-width: 100%;
    box-sizing: border-box;
`;

export const ButtonsRow = styled(RowDiv)`
    justify-content: flex-start;
    gap: 8px;
`;

export const StyledButton = styled(Button)`
    && {
        width: 100px;
        height: 28px;
        font-size: 0.7rem;
        padding: 4px 8px;
        word-wrap: break-word;
        white-space: nowrap;
        border-radius: 5px;
    }
`;
